/* BrandingIcon.js */

"use strict";
const ActionableIcon = require("../actionable/ActionableIcon");

class BrandingIcon extends ActionableIcon {

    createdCallback(){
        super.createdCallback(arguments);
    }

    attachedCallback(){
        super.attachedCallback(arguments);
    }

    attributeChangedCallback(/*attrName, oldVal, newVal*/){
        super.attributeChangedCallback(arguments);
    }

    detachedCallback(){
        super.detachedCallback(arguments);
    }

}

let icon,
    customElementRegistry = window.customElements;

if (customElementRegistry) {
    icon = customElementRegistry.get('branding-icon-gl');
    if (!icon) {
        customElementRegistry.define('branding-icon-gl', BrandingIcon);
        icon = customElementRegistry.get('branding-icon-gl');
    }
} else if (document.registerElement) {
    icon = document.registerElement('branding-icon-gl', BrandingIcon);
} else {
    icon = BrandingIcon;
}

module.exports = icon;